<template>
  <div class="main main__container register-user-container">
    <h1 class="h1-bold">
      {{ declineInvite ? t('declineRegisterUserHeader') : t('registerUserHeader') }}
    </h1>
    <template v-if="declineInvite">
      <oie-form-wrapper class="information-island inputs-container" @submit="handleDeclineInvite">
        <template v-if="!declinedSuccessfully">
          <div class="body-smaller" v-html="t('declineRegisterUserInfoText')">
          </div>
          <oie-action-wrapper>
            <oie-base-action type="submit" size="large" theme="destructive">
              {{ t('declineRegisterUserButton') }}
            </oie-base-action>
          </oie-action-wrapper>
        </template>
        <div v-else v-html="t('declineSuccessfullyMessage')">
        </div>
      </oie-form-wrapper>
    </template>
    <template v-else-if="notValid">
      <div class="information-island inputs-container" v-html="notValidInfoText"></div>
    </template>
    <validation-observer v-else ref="observer" class="register-user-container__register">
      <oie-form-wrapper class="inputs-container" @submit="handleCreateUser">
        <div class="body-smaller" v-html="t('registerUserInfoText')"></div>

        <validation-provider
          v-slot="{errors}"
          rules="required"
          slim>
          <oie-base-input-v2
            v-model="user.firstName"
            required
            :label="tStatic('firstNameLabel')"
            :placeholder="tStatic('firstNamePlaceholder')"
            :maxlenght="80"
            :errors="errors">
          </oie-base-input-v2>
        </validation-provider>

        <validation-provider
          v-slot="{errors}"
          rules="required"
          slim>
          <oie-base-input-v2
            v-model="user.lastName"
            required
            :label="tStatic('lastNameLabel')"
            :placeholder="tStatic('lastNamePlaceholder')"
            :maxlenght="80"
            :errors="errors">
          </oie-base-input-v2>
        </validation-provider>

        <validation-provider
          v-slot="{errors}"
          rules="required|mobile:^[0-9+]+$"
          slim>
          <oie-phone-input
            v-model="user.mobile"
            required
            name="phone"
            autocomplete="tel-national"
            :label="tStatic('phoneLabel')"
            :placeholder="tStatic('phonePlaceholderLabel')"
            :maxlength="27"
            :errors="errors"
            :country-code="selectedActiveCountry ? selectedActiveCountry.callingCode : null">
          </oie-phone-input>
        </validation-provider>

        <validation-provider
          v-slot="{errors}"
          vid="pw"
          rules="required|passwordPolicy"
          slim>
          <oie-base-input-v2
            v-model="user.password"
            type="password"
            autocomplete="new-password"
            required
            :label="tStatic('password')"
            :placeholder="tStatic('passwordPlaceholder')"
            :description="tStatic('passwordPolicy')"
            :errors="errors"></oie-base-input-v2>
        </validation-provider>

        <validation-provider
          v-slot="{errors}"
          rules="required|password:pw"
          slim>
          <oie-base-input-v2
            v-model="reEnteredPassword"
            type="password"
            :label="tStatic('passwordMatch')"
            required
            :placeholder="tStatic('passwordMatchPlaceholder')"
            :errors="errors">
          </oie-base-input-v2>
        </validation-provider>

        <oie-action-wrapper>
          <oie-base-action type="submit" size="large">
            {{ t('registerUserButton') }}
          </oie-base-action>
        </oie-action-wrapper>
      </oie-form-wrapper>
    </validation-observer>
  </div>
</template>

<script>
import countryHandling from '@/mixins/country-handling'
import httpService from '@/core/http-service'

export default {
  mixins: [countryHandling],
  props: {
    userId: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    },
    declineInvite: {
      type: Boolean,
      default: false
    },
    notValid: {
      type: Boolean,
      default: false
    },
    notValidInfoText: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      user: {
        firstName: '',
        lastName: '',
        mobile: '',
        password: ''
      },
      reEnteredPassword: '',
      declinedSuccessfully: false

    }
  },

  async beforeMount() {
    if(this.defaultCountry) this.setActiveCountry(this.defaultCountry.value)
  },
  methods: {
    async handleCreateUser() {
      const isValid = await this.$refs.observer.validate()
      if(isValid) {
        httpService.post('auth/invite/createuser', { ...this.user, token: this.token }).then((response) => {
          window.location = response.data.url
        }).catch(() => {
        })
      }
    },
    async handleDeclineInvite() {
      httpService.post('auth/invite/decline', { token: this.token }).then((response) => {
        this.declinedSuccessfully = true
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="scss">
.register-user-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: measure(half);

  @include media('medium') {
    gap: measure(full);
  }
}

.register-user-container__register {
  padding: measure(half);
  border: 1px solid color(border-gray);
  background-color: color(background-white);
}

.register-user-container__register .inputs-container {
  max-width: 75ch;
}
</style>
